let didRedirectLoggedInUserToWorkspace = false;

/**
 * Starts a single auth-route to workspace redirect for the current page lifetime.
 */
export const startLoggedInUserWorkspaceRedirect = (): boolean => {
    if (didRedirectLoggedInUserToWorkspace) return false;

    didRedirectLoggedInUserToWorkspace = true;
    return true;
};

/**
 * Allows future auth-route to workspace redirects after a stable destination has loaded.
 */
export const resetLoggedInUserWorkspaceRedirect = (): void => {
    didRedirectLoggedInUserToWorkspace = false;
};
